<div class="notification-bell">
  <!-- Bell button -->
  <button
    class="notification-bell__btn"
    data-cy="btn-notification-bell"
    (click)="toggleDropdown()"
    [attr.aria-expanded]="isDropdownOpen"
    aria-label="Notificaciones"
  >
    <i class="mdi mdi-bell-outline notification-bell__icon"></i>
    <span
      class="notification-bell__badge"
      data-cy="notification-badge"
      *ngIf="(pendingCount$ | async) as count"
    >
      {{ count > 99 ? '99+' : count }}
    </span>
  </button>

  <!-- Dropdown panel -->
  <div class="notification-bell__dropdown" *ngIf="isDropdownOpen" data-cy="notification-dropdown">
    <!-- Header -->
    <div class="notification-bell__header">
      <span class="notification-bell__header-title">Notificaciones</span>
      <button
        class="notification-bell__mark-all"
        data-cy="btn-mark-all-read"
        (click)="markAllAsRead()"
      >
        Marcar todas como leidas
      </button>
    </div>

    <!-- Notification list -->
    <div class="notification-bell__list" *ngIf="notificaciones$ | async as notificaciones">
      <!-- Empty state -->
      <div class="notification-bell__empty" *ngIf="notificaciones.length === 0" data-cy="notification-empty">
        <i class="mdi mdi-bell-off-outline"></i>
        <span>No hay notificaciones</span>
      </div>

      <!-- Notification items -->
      <div
        *ngFor="let notif of notificaciones; trackBy: trackById"
        class="notif-item"
        [attr.data-cy]="'notification-' + notif.id"
        [class.notif-item--unread]="!notif.leida"
        (click)="markAsRead(notif)"
        (keydown.enter)="markAsRead(notif)"
        tabindex="0"
        role="button"
      >
        <!-- Type icon -->
        <div class="notif-item__icon notif-icon" [ngClass]="getTypeClass(notif.tipo)">
          <i class="mdi {{ getTypeIcon(notif.tipo) }}"></i>
        </div>

        <!-- Content -->
        <div class="notif-item__content">
          <span class="notif-item__title">{{ notif.titulo }}</span>
          <span class="notif-item__message">{{ notif.mensaje }}</span>
          <span class="notif-item__time">{{ getRelativeTime(notif.fechaCreacion) }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
